export default "__VITE_ASSET__DKsPPiUg__"